import {useMemo} from 'react';
import type {HomeData} from './HomeDataContext';
import {useChecklistSteps} from './useChecklistSteps';
import {useStaySummary} from './useStaySummary';

export function useHomeDataState(): HomeData {
  const stay = useStaySummary();
  const {steps: navItems, isLoading: navLoading} = useChecklistSteps();

  return useMemo<HomeData>(
    () => ({
      ...stay,
      navItems,
      navLoading,
    }),
    [stay, navItems, navLoading],
  );
}
